import React from 'react';
import styles from 'componets/text-input/index.module.scss';
import classNames from 'classnames/bind';
import CoreInput from 'componets/core-input';
import { CloseIcon } from 'icons';

const cx = classNames.bind(styles);

const TextInput = ({
  icon,
  type,
  placeholder,
  onTextChange,
  onKeyPress,
  maxLength,
  newText,
  digits,
  textAllCaps = false,
  onClear,
  onFocus,
  errorMessage,
  isInvalid = false,
}) => {
  const Icon = () => {
    if (icon) {
      return <img className={styles.icon} src={icon} alt="icon" onClick={onClear} />;
    } else return <></>;
  };

  const ClearIcon = () => {
    if (newText) {
      return <CloseIcon width={24} height={24} color="#333333" className={styles.clear} onClick={onClear} />;
    } else {
      return <></>;
    }
  };

  const containerClass = cx({
    inputContent: true,
    invalid: isInvalid || !!errorMessage,
  });

  return (
    <>
      {' '}
      <div className={containerClass}>
        <Icon />
        <CoreInput
          icon={icon}
          textAllCaps={textAllCaps}
          digits={digits}
          placeholder={placeholder}
          newText={newText}
          onKeyPress={onKeyPress}
          type={type}
          maxLength={maxLength}
          onTextChange={onTextChange}
          onFocus={onFocus}
        />
        {onClear && <ClearIcon />}
      </div>
      {errorMessage && <small className={styles['error-message']}>{errorMessage}</small>}
    </>
  );
};

export default TextInput;
